"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuilderBackground = void 0;
var BuilderBackground = {
  ONE_TO_MANY: 'ONE_TO_MANY',
  GIFT_REDEMPTION: 'GIFT_ REDEMPTION',
  CUSTOM_KIT: 'CUSTOM_KIT',
  PROSPECTING: 'PROSPECTING'
};
exports.BuilderBackground = BuilderBackground;